import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=2864a536&"
import script from "./TemplateCard.vue?vue&type=script&lang=js&"
export * from "./TemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports